import styled, { css } from 'styled-components';
export const Title = styled.h4 `
  ${({ theme: { quickPayTitle } }) => quickPayTitle}
`;
export const PaymentButton = styled.button `
  -webkit-appearance: none;
  appearance: none;
  border: none;
  background-color: white;
  border-radius: .6rem;
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #000000;
  font-family: var(--body-font);
  width: 100%;
  padding: 1.1rem 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  transition: opacity .4s linear;
  
  span {
    align-items: center;
  }
  
  img {
    max-width: 5.8rem;
    margin-left: .4rem;
  }
  
  & + & {
    margin-top: 1rem;
  }

  ${({ isDisabled }) => isDisabled && css `
    opacity: 0.4;
    cursor: not-allowed;
  `}

  ${({ isDark }) => isDark && css `
    color: #fff;
    background-color: #000;
    border-color: #000;
  `}

  &:disabled {
    opacity: 0.4;
  }
`;
export const Wrapper = styled.div `
  ${({ theme: { quickPayWrapper } }) => quickPayWrapper}

  width: 100%;
  
  ${PaymentButton} {
    width: 100%;
  }
`;
export default {
    Wrapper,
};
